import createDOMPurify from "dompurify";

// Свой экземпляр: правила FAQ не меняют очистку HTML в других компонентах.
const purifier = createDOMPurify(window);
const HIGHLIGHT_CLASSES = new Set(["marker-yellow", "marker-green", "marker-pink"]);
const LINK_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);

purifier.addHook("uponSanitizeAttribute", (node, data) => {
  if (data.attrName !== "class") return;
  if (node.nodeName !== "MARK") {
    data.keepAttr = false;
    return;
  }
  data.attrValue = data.attrValue
    .split(/\s+/)
    .filter(value => HIGHLIGHT_CLASSES.has(value))
    .join(" ");
  if (!data.attrValue) data.keepAttr = false;
});

purifier.addHook("afterSanitizeAttributes", node => {
  if (node.nodeName !== "A") return;
  const href = node.getAttribute("href");
  if (href) {
    try {
      // Без базового URL: относительные ссылки между разными доменами не нужны.
      if (!LINK_PROTOCOLS.has(new URL(href).protocol)) {
        node.removeAttribute("href");
      }
    } catch {
      node.removeAttribute("href");
    }
  }
  node.setAttribute("target", "_blank");
  node.setAttribute("rel", "noopener noreferrer");
});

export function sanitizeFaqHtml(value) {
  return purifier.sanitize(String(value || ""), {
    ALLOWED_TAGS: [
      "p", "br", "strong", "b", "em", "i", "u", "s", "a",
      "ul", "ol", "li", "blockquote", "mark",
    ],
    ALLOWED_ATTR: ["href", "title", "class"],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });
}